import { gql } from 'apollo-boost';

export const SEARCH_HOUSEHOLDS = gql`
  query HOUSEHOLDS($page: Int = 1, $search: String) {
    households(search: $search, page: $page) {
      total
      page
      pages
      docs {
        id
        primary {
          person {
            id
            lastName
            firstName
            avatar
          }
        }
        people {
          id
          lastName
          firstName
          relationship
          primary
          avatar
        }
      }
    }
  }
`;

export const HOUSEHOLD = gql`
  query HOUSEHOLD($id: ID) {
    household(id: $id) {
      id
      constraintVipAllowance
      vip
      primary {
        person {
          id
          firstName
          lastName
          addressLineOne
          addressLineTwo
          city
          state
          postal
        }
        user {
          id
          email
          phone
        }
      }
      activity {
        date
        type
        event {
          date
          id
          name
        }
      }
      people {
        id
        firstName
        lastName
        avatar
        relationship
        household {
          id
          primary {
            person {
              id
              lastName
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_HOUSEHOLD = gql`
  mutation UPDATE_HOUSEHOLD($id: String, $input: UpdateVIPStatusInput) {
    updateVipStatus(id: $id, input: $input)
  }
`;
